import { render, staticRenderFns } from "./colleague.vue?vue&type=template&id=575c2fe2&scoped=true&"
import script from "./colleague.vue?vue&type=script&lang=js&"
export * from "./colleague.vue?vue&type=script&lang=js&"
import style0 from "./colleague.vue?vue&type=style&index=0&id=575c2fe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575c2fe2",
  null
  
)

export default component.exports